import {
    apiRequest,
    CuttingCategoryDetail,
    CuttingCategoryUpdate
} from "../../../../../services/adapters/master/cuttingCategoryService"

class CreateRepository {

    fetchDetail = async (query) => {
        return await apiRequest("get", CuttingCategoryDetail, {
            params: query
        }, true)
    }
    fetchUpdate = async (query) => {
        return await apiRequest("post", CuttingCategoryUpdate, {
            body: query
        }, true)
    }
    

}

export default CreateRepository